import React from 'react';
import { LabeledSelect, colors } from '@commonsku/styles';
import { MultiSelectFilterProps } from './types';

const MultiSelectFilter: React.FC<MultiSelectFilterProps> = ({
  label,
  options,
  value,
  onChange,
  isClearable = false,
}) => {
  return (
    <LabeledSelect
      controlStyles={{ justifyContent: 'flex-start' }}
      label={label}
      isMulti
      singleValueStyles={{ fontSize: 14, fontWeight: '600', color: colors.primary1['65'] }}
      menuStyles={{ borderRadius: 5 }}
      value={value}
      onChange={onChange}
      isClearable={isClearable}
      options={options}
    />
  );
};

export default MultiSelectFilter;
